module.exports = __webpack_public_path__ + "static/media/comments.1182fbfb.svg";